// Logo da empresa: validação no cliente, envio e leitura como blob autenticado
// (o <img src> não envia o Bearer, então o logo é buscado via axios).
// Mesmas regras do servidor: JPG/PNG/WEBP/GIF, até 5 MB.
import { empresaService } from "@services/api";

export const LOGO_TIPOS_ACEITOS = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
];
export const LOGO_TAMANHO_MAX_BYTES = 5 * 1024 * 1024;
export const LOGO_ACCEPT = LOGO_TIPOS_ACEITOS.join(",");

// Retorna a mensagem de erro, ou `null` quando o arquivo é aceito.
export const validarLogoEmpresa = (file) => {
  if (!file) return "Selecione um arquivo de imagem.";
  if (!LOGO_TIPOS_ACEITOS.includes(file.type)) {
    return "Formato inválido. Utilize imagens JPG, PNG, WEBP ou GIF.";
  }
  if (file.size === 0) return "O arquivo selecionado está vazio.";
  if (file.size > LOGO_TAMANHO_MAX_BYTES) {
    return "Arquivo muito grande. Tamanho máximo: 5MB.";
  }
  return null;
};

// Devolve os dados da empresa atualizados (`tem_logo` e `logo_at`).
// Quem chama deve validar o arquivo com `validarLogoEmpresa` antes.
export const enviarLogoEmpresa = async (empresaId, file) => {
  const response = await empresaService.uploadLogo(empresaId, file);
  return response.data?.data;
};

export const fetchEmpresaLogoBlob = async (empresaId) => {
  const response = await empresaService.getLogo(empresaId);
  return response.data;
};
